import React from "react";
import DesktopNav from "./Desktop/DesktopNav";
import MobileNav from "./Mobile/MobileNav";
import ResponsiveView from "../../ui/responsive/ResponsiveView";

const Nav = () => {
  return (
    <ResponsiveView
      desktop={<DesktopNav />}
      tablet={<DesktopNav />}
      mobile={<MobileNav />}
    />
  );
};

export default Nav;
